import React, { useCallback } from 'react';
import { ChangeHandler, useFormContext } from 'react-hook-form';

import { Label, RadioCardGroup } from '@printdeal/ui-library';
import { OptionProps } from './types/FileDesignTypes';
import DesignOptionRadio from './DesignOptionRadio';
import DesignOptionsError from './DesignOptionsError';
import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface Props {
  fieldName: string;
  title: string;
  options: OptionProps[];
  dispatchEventCategory?: DispatchCategoriesAccount;
}

const DesignOptionsRadio = ({
  fieldName,
  title,
  options,
  dispatchEventCategory = 'order_detail_interaction',
}: Props) => {
  const {
    register,
    setValue,
  } = useFormContext();

  const fieldRegistration = register(fieldName);

  const handleOnChange:ChangeHandler = useCallback(async (event) => {
    await setValue(fieldName, event.target.value);
    await fieldRegistration.onChange(event);
    dispatchAccountEvent(dispatchEventCategory, 'file_design_field_interaction - click', { fieldName });
  }, [dispatchEventCategory, fieldName, fieldRegistration, setValue]);

  return (
    <>
      <p className="pd-mt-2">
        <Label>{ title } <span className="pd-ml-1 pd-text-error-500" aria-hidden="true">*</span></Label>
      </p>
      <DesignOptionsError fieldName={fieldName} maxVal={1} />
      <RadioCardGroup
        id={fieldName}
        {...fieldRegistration}
        onChange={(e) => { handleOnChange(e); }}
      >
        <RadioCardGroup.Fields
          className="lg:pd-grid lg:pd-grid-cols-5"
        >
          {
            options.map((option) => (
              <DesignOptionRadio
                key={option.title}
                fieldName={fieldName}
                option={option}
              />
            ))
          }
        </RadioCardGroup.Fields>
      </RadioCardGroup>
    </>
  );
};

export default DesignOptionsRadio;
